import { render, staticRenderFns } from "./SelectWorkspace.vue?vue&type=template&id=e56c660c&scoped=true&lang=pug"
import script from "./SelectWorkspace.vue?vue&type=script&lang=js"
export * from "./SelectWorkspace.vue?vue&type=script&lang=js"
import style0 from "./SelectWorkspace.vue?vue&type=style&index=0&id=e56c660c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56c660c",
  null
  
)

export default component.exports